var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyCallTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 17"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 26",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "forward"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1283_1114",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 12,
    y: 12,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1283_1114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "forward_2",
    d: "M22.6668 23.3335L21.7168 22.4002L24.7835 19.3335L21.7168 16.2668L22.6668 15.3335L26.6668 19.3335L22.6668 23.3335ZM13.3335 24.6668V22.0002C13.3335 21.0779 13.6585 20.2918 14.3085 19.6418C14.9585 18.9918 15.7446 18.6668 16.6668 18.6668H20.7835L18.3835 16.2668L19.3335 15.3335L23.3335 19.3335L19.3335 23.3335L18.3835 22.4002L20.7835 20.0002H16.6668C16.1113 20.0002 15.6391 20.1946 15.2502 20.5835C14.8613 20.9724 14.6668 21.4446 14.6668 22.0002V24.6668H13.3335Z",
    fill: "#9B9B9B"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyCallTransfer);
export default __webpack_public_path__ + "static/media/grey-call-transfer.26ab1729791491dea21fed83aac9c083.svg";
export { ForwardRef as ReactComponent };